'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _plugin = require('@swup/plugin');

var _plugin2 = _interopRequireDefault(_plugin);

var _onDemandLiveRegion = require('on-demand-live-region');

var _onDemandLiveRegion2 = _interopRequireDefault(_onDemandLiveRegion);

require('focus-options-polyfill');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SwupA11yPlugin = function (_Plugin) {
	_inherits(SwupA11yPlugin, _Plugin);

	function SwupA11yPlugin() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		_classCallCheck(this, SwupA11yPlugin);

		var _this = _possibleConstructorReturn(this, (SwupA11yPlugin.__proto__ || Object.getPrototypeOf(SwupA11yPlugin)).call(this));

		_this.name = 'SwupA11yPlugin';

		_this.announceVisit = function () {
			requestAnimationFrame(function () {
				_this.announcePageName();
				_this.focusPageContent();
			});
		};

		_this.announcePageName = function () {
			var _this$options = _this.options,
			    contentSelector = _this$options.contentSelector,
			    headingSelector = _this$options.headingSelector,
			    urlTemplate = _this$options.urlTemplate,
			    announcementTemplate = _this$options.announcementTemplate;

			// Default: announce new /path/of/page.html

			var pageName = urlTemplate.replace('{url}', window.location.pathname);

			// Check for title tag
			if (document.title) {
				pageName = document.title;
			}

			// Look for first heading in content container
			var content = document.querySelector(contentSelector);
			if (content) {
				var headings = content.querySelectorAll(headingSelector);
				if (headings && headings.length) {
					var _headings = _slicedToArray(headings, 1),
					    heading = _headings[0];

					pageName = heading.getAttribute('aria-label') || heading.textContent;
				}
			}

			var announcement = announcementTemplate.replace('{title}', pageName.trim());
			_this.liveRegion.say(announcement);
		};

		_this.focusPageContent = function () {
			var content = document.querySelector(_this.options.contentSelector);
			if (content) {
				content.setAttribute('tabindex', '-1');
				content.focus({ preventScroll: true });
			}
		};

		_this.onTransitionStart = function () {
			document.documentElement.setAttribute('aria-busy', 'true');
		};

		_this.onTransitionEnd = function () {
			document.documentElement.removeAttribute('aria-busy');
		};

		_this.options = _extends({
			contentSelector: 'main',
			headingSelector: 'h1, h2, [role=heading]',
			announcementTemplate: 'Navigated to: {title}',
			urlTemplate: 'New page at {url}'
		}, options);

		_this.liveRegion = new _onDemandLiveRegion2.default();
		return _this;
	}

	_createClass(SwupA11yPlugin, [{
		key: 'mount',
		value: function mount() {
			this.swup.on('contentReplaced', this.announceVisit);
			this.swup.on('transitionStart', this.onTransitionStart);
			this.swup.on('transitionEnd', this.onTransitionEnd);
		}
	}, {
		key: 'unmount',
		value: function unmount() {
			this.swup.off('contentReplaced', this.announceVisit);
			this.swup.off('transitionStart', this.onTransitionStart);
			this.swup.off('transitionEnd', this.onTransitionEnd);
		}
	}]);

	return SwupA11yPlugin;
}(_plugin2.default);

exports.default = SwupA11yPlugin;